export const TODO_TEXT_PADDING = (tiny: boolean | undefined) => (tiny ? 6 : 8);
// tiny is only for calendar mode - if this changes, we need to update all usages of this method
export const TODO_LINE_HEIGHT = (tiny: boolean | undefined) => (tiny ? 12 : 20);
export const TODO_CHECKBOX_SIZE = (tiny: boolean | undefined) => (tiny ? 16 : 20);
export const TODO_ITEM_HEIGHT = (tiny: boolean | undefined) => TODO_LINE_HEIGHT(tiny) + 2 * TODO_TEXT_PADDING(tiny);
export const TODO_ITEM_WIDTH = 240;
export const TODO_INDENT_WIDTH = (tiny: boolean | undefined) => (tiny ? 12 : 20);
export const TODO_META_ICON_SIZE = (tiny: boolean | undefined) => (tiny ? 12 : 16);

export const DOCUMENT_PADDING = 8;
export const TOP_HEADER_HEIGHT = 32;
export const LEFT_SIDEBAR_WIDTH = 100;
